import { useDispatch } from 'react-redux';
import { fetchPhaseData, setStrategyData } from './phasesSlice';
import { PhasesTab } from './PhasesTab';
import { useEffect } from 'react';

export const PhasesProvider = ({
  strategyNumber,
  activePhase,
  userInfoMap
}) => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (strategyNumber === undefined) return;

    dispatch(fetchPhaseData({ strategyNumber: strategyNumber }));
    dispatch(setStrategyData({ activePhase, strategyNumber }));
  }, [dispatch, strategyNumber, activePhase]);

  return <PhasesTab userInfoMap={userInfoMap} strategyId={strategyNumber} />;
};
